import type { ReactNode, RefObject } from 'react';
import { below } from '@voll-intelligence/ui-kit/breakpoints';
import type { BusOfferView } from '../models.js';
import type { BusSeatLayout } from '../seats/bus_seat_picker.js';
import { BusSeatTakeover } from './bus_seat_takeover.js';

/**
 * Abaixo da régua `wide` do shell (880) — o celular E o tablet, como no pacote
 * Flutter (`isMobile || isTablet`) — a escolha de poltrona sai do card e abre
 * em tela cheia, na casca da tela de tarifas do voo, com a planta em pé. A
 * régua do palco estreito (`NARROW_STAGE_QUERY`, 640) deixaria o tablet com a
 * planta deitada rolando de lado. Vale para a página e para o card da conversa.
 */
export const BUS_SEAT_SHEET_QUERY = below('wide');

/** A escolha de poltrona em tela cheia: o MESMO miolo do card, em pé, com a
 *  linha da viagem no cabeçalho. Fechada (sem `offer`), não monta. */
export function BusSeatSheet({
  offer,
  title,
  closeLabel,
  renderExpansion,
  returnFocusTo,
  onClose,
}: {
  readonly offer: BusOfferView | undefined;
  readonly title: string;
  readonly closeLabel: string;
  readonly renderExpansion: (offerId: string, layout: BusSeatLayout) => ReactNode;
  readonly returnFocusTo: RefObject<HTMLElement | null>;
  readonly onClose: () => void;
}): ReactNode {
  if (!offer) return null;
  return (
    <BusSeatTakeover
      title={title}
      subtitle={[offer.headline, offer.company.name].join(' · ')}
      backLabel={closeLabel}
      returnFocusTo={returnFocusTo}
      onClose={onClose}
    >
      {renderExpansion(offer.id, 'sheet')}
    </BusSeatTakeover>
  );
}
